module.exports = __webpack_public_path__ + "img/en_badge_web_generic.43f8bc91.png";